import React, {useState, useEffect} from 'react';
import { Provider } from 'react-redux';
import StyleContext from 'isomorphic-style-loader/StyleContext';
import ApplicationContext from './ApplicationContext';
import store from '../store';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import NoSsr from '@mui/material/NoSsr';
import toastr from 'toastr';

const theme = createTheme({
  palette: {
    mode: 'light',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0px 2px 8px rgba(92, 83, 83, 0.08)'
        }
      }
    }
  },
  typography: {
    "fontFamily": `"Be Vietnam", sans-serif`
  }
});

export default function App({ context, insertCss, children }) {
  useEffect(()=>{
      if (toastr) {
        toastr.options = {
          "closeButton": true,
          "debug": false,
          "progressBar": true,
          "preventDuplicates": false,
          "positionClass": "toast-top-right",
          "onclick": null,
          "showDuration": "400",
          "hideDuration": "1000",
          "timeOut": "5000",
          "extendedTimeOut": "1000",
          "showEasing": "swing",
          "hideEasing": "linear",
          "showMethod": "slideDown",
          "hideMethod": "slideUp"
        }
      }
  }, [])
  // NOTE: If you need to add or modify header, footer etc. of the app,
  // please do that inside the Layout component.
  return (
    <NoSsr>
    <StyleContext.Provider value={{ insertCss }}>
      <ApplicationContext.Provider value={{ context }}>
        <Provider store={store}>
        <ThemeProvider theme={theme}>
        <CssBaseline/>
        {
          React.Children.only(children)
        }
        </ThemeProvider>
        </Provider>
      </ApplicationContext.Provider>
    </StyleContext.Provider>
    </NoSsr>
  );
}
